import {
  ID,
  noDeadlineSectionID,
  overdueSectionID,
  ReorderItem,
  ReorderResult,
  Task,
  TaskListItemTypes,
} from '@griply/types';
import { endOfDay } from 'date-fns';
import cloneDeep from 'lodash/cloneDeep';

import { parseDateKey } from '../format-date-key';
import { findParentItem } from './find-parent-item';

export type OnDeadlineDeadlineReorderOptions = {
  updatedItems: readonly ReorderItem[];
  tasksMap: Record<ID, Task>;
};

export const onDeadlineDeadlineReorder = ({
  updatedItems,
  tasksMap,
}: OnDeadlineDeadlineReorderOptions): ReorderResult => {
  const updatedTasks: Task[] = [];

  updatedItems.forEach((item) => {
    if (item.type !== TaskListItemTypes.Task) {
      return;
    }

    if (!tasksMap[item.id]) {
      return;
    }

    const task = tasksMap[item.id];
    const taskToUpdate = cloneDeep(task);

    const newSectionItem = findParentItem(updatedItems, item.id);

    if (!newSectionItem) {
      return;
    }

    const newSectionId = newSectionItem.id;

    if (newSectionId === overdueSectionID) {
      return;
    }

    if (newSectionId === noDeadlineSectionID) {
      if (task.deadlineDeadline) {
        taskToUpdate.deadlineDeadline = null;
        updatedTasks.push(taskToUpdate);
      }
      return;
    }

    const newDate = parseDateKey(newSectionId);
    const newDeadline = endOfDay(newDate);

    if (
      !task.deadlineDeadline ||
      task.deadlineDeadline.getTime() !== newDeadline.getTime()
    ) {
      taskToUpdate.deadlineDeadline = newDeadline;
      updatedTasks.push(taskToUpdate);
    }
  });

  return { updatedSections: [], updatedTasks };
};
